import { SortDescriptor } from "react-aria-components";

import { MODULE_WEBHOOKS_COLUMN_ID } from "./constants";
import { WebhookIntegrationWithTimestamp } from "./types";

const compareModuleWebhooks = (
  a: WebhookIntegrationWithTimestamp,
  b: WebhookIntegrationWithTimestamp,
  column: SortDescriptor["column"]
) => {
  switch (column) {
    case MODULE_WEBHOOKS_COLUMN_ID.ENDPOINT:
      return a.endpoint.localeCompare(b.endpoint, undefined, { numeric: true });
    case MODULE_WEBHOOKS_COLUMN_ID.STATUS:
      return Number(a.enabled) - Number(b.enabled);
    case MODULE_WEBHOOKS_COLUMN_ID.CREATED_AT:
      return a.createdAt - b.createdAt;
    default:
      return 0;
  }
};

export const sortModuleWebhooks = (
  webhooks: WebhookIntegrationWithTimestamp[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return webhooks;
  }

  const direction = sortDescriptor.direction === "ascending" ? 1 : -1;

  return [...webhooks].sort(
    (a, b) => compareModuleWebhooks(a, b, sortDescriptor.column) * direction
  );
};
